(function (angular, _, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('CalculateModel', ['$http', '$q', function ($http, $q) {
            var CalculateModel = function () {

            };

            CalculateModel.prototype = {
                /**
                 *
                 * @returns {deferred.promise|{then, always}}
                 */
                quotes: function( quoteData ) {
                    var scope = this;
                    var deferred = $q.defer();

                    $http({
                        method: 'GET',
                        url: '/api/v1/calculate/quotes',
                        params: quoteData
                    }).then(
                        function successCallback(response) {
                            var data = response.data;
                            data.content.healthRates = data.content.healthRates;
                            deferred.resolve(data);
                        },
                        function errorCallback() {
                            deferred.resolve({result: false, message: 'Timeout while calculating the quote, please try again later.'});
                        }
                    );
                    return deferred.promise;
                }
            };
            return new CalculateModel();
        }]);
})(angular, _, window);
